import React from 'react';
import classes from './OrderDetailPage.css';
import Burger from '../../Burger/Burger';
import OrderSummary from '../../Burger/OrderSummary/OrderSummary';
import { withRouter } from 'react-router-dom'


const orderDetailPage = (props) => {
  if (!props.order) {
    props.history.push('/orders')
  }
  const fullOrderDate = new Date(props.order.orderTime);
  const orderDate = fullOrderDate.toDateString();
  const orderTime = fullOrderDate.toTimeString().replace(' GMT-0400 (Eastern Daylight Time)', '');
  console.log(orderDate, orderTime);

  return <div className={classes.OrderDetailPage}>
    <div className={classes.DetailCard}>
      <div className={[classes.DetailWrapper, classes.DetailHeader].join(' ')}>
        <div className={classes.CardRow}>
          <h1 className={classes.OrderDetailPageTitle}>Order {props.order.orderID}</h1>
          <p className={classes.GoBack} onClick={() => { props.history.push('/orders') }}>&#8592; Return to orders</p>
        </div>
      </div>
      <div className={classes.DetailWrapper}>
        <Burger ingredients={props.order.ingredients} />
      </div>
      <hr />
      <div className={classes.DetailWrapper}>
        <OrderSummary ingredients={props.order.ingredients} prices={props.prices} total={props.order.price} title={'Price'} />
        <hr />
        <div className={classes.OrderDetailsItems}>
          <h2>Order Details</h2>
          <br />
          <h3>Name</h3>
          <p><b>First - </b> {props.order.customer.name.firstName}</p>
          <p><b>Last - </b> {props.order.customer.name.lastName}</p>
          <br />
          <h3>Address</h3>
          <p><b>City - </b> {props.order.customer.address.city}</p>
          <p><b>State - </b> {props.order.customer.address.state}</p>
          <p><b>Street Address - </b> {props.order.customer.address.streetAddress}</p>
          <br />
          <h3>Contact Details</h3>
          <p><b>Email - </b> {props.order.customer.email}</p>
          <p><b>Phone - </b> {props.order.customer.phone}</p>
          <br />
          <h3>Delivery Info</h3>
          <p><b>Order Time - </b>{`${orderDate} ${orderTime}`} </p>
          <p><b>Delivery Method - </b> {props.order.deliveryMethod}</p>
          <p><b>Delivery Instructions - </b> {props.order.instructions}</p>
        </div>
      </div>
    </div>
  </div>
}

export default withRouter(orderDetailPage);


// WEBPACK FOOTER //
// ./src/components/Order/OrderDetailPage/OrderDetailPage.jsx